import useAxios from 'hooks/useAxios'
import React, { useEffect, useState } from 'react'
import { Message, Form, Button } from 'semantic-ui-react'
import { Loader } from '../../../shared/components/Loader'
import { toast } from 'libs/toast'
import LoginMethodCheckboxGroup from 'components/LoginMethodCheckboxGroup'
import { getAxios } from 'api'

export default function LoginMethod({ isEnabledSSO, connection, companyId }) {
  const [loginMethodsState, setLoginMethodsState] = useState([])
  const [isCompanyDataLoading, setIsCompanyDataLoading] = useState(true)

  const { fetch: updateCompanyData, loading: isUpdateCompanyDataLoading } = useAxios({
    url: `account/company/${companyId}/`,
    method: 'patch',
    skip: true,
  })

  // use getAxios to prevent random infinite loading when use useAxios loading
  useEffect(() => {
    getAxios()
      .get(`account/company/${companyId}/`)
      .then((res) => {
        setIsCompanyDataLoading(false)
        setLoginMethodsState(res.data.login_methods)
      })
      .catch((err) => {
        setIsCompanyDataLoading(false)
        toast.error('Oops! Something went wrong. Please try again.')
        console.error(err)
      })
  }, [companyId])

  const isSSOConnectionActive = isEnabledSSO && connection && connection.status === 'active'

  function handleSubmit(e) {
    e.preventDefault()

    if (loginMethodsState.length < 1) {
      toast.error('At least one login method is required')
      return
    }

    updateCompanyData({ data: { login_methods: loginMethodsState } })
      .then(() => {
        toast.success('Login methods updated')
      })
      .catch((err) => {
        toast.error('Failed to update login methods')
        console.error(err)
      })
  }

  const handleChange = (e, { value, checked }) => {
    setLoginMethodsState((prev) => {
      if (checked) {
        return [...prev, value]
      } else {
        return prev.filter((method) => method !== value)
      }
    })
  }

  function getContent() {
    if (isCompanyDataLoading) {
      return <Loader withContainer />
    } else {
      return (
        <Form>
          <LoginMethodCheckboxGroup
            loginMethods={loginMethodsState}
            onChangeLoginMethods={handleChange}
          />
          <Button
            primary
            onClick={handleSubmit}
            loading={isUpdateCompanyDataLoading}
            disabled={isUpdateCompanyDataLoading}
          >
            Save settings
          </Button>
        </Form>
      )
    }
  }

  return (
    <React.Fragment>
      <h2 className="ui header">Login methods</h2>
      <p>Manage the login options available to your team.</p>
      {isSSOConnectionActive && (
        <Message>
          <p>
            These settings apply to users where SSO is optional, either because it's disabled for
            their account or they've been excluded from the SSO requirement.
          </p>
        </Message>
      )}
      <a
        target="_blank"
        rel="noreferrer"
        href="https://help.simplesat.io/en/articles/8340321-login-methods-and-single-sign-on#login-methods"
      >
        <i className="icon far fa-book" />
        Learn more about login methods
      </a>
      {getContent()}
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/Admin/Authentication/LoginMethod.js